import React from 'react';
import cn from 'classnames';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSpinnerThird } from '@fortawesome/pro-regular-svg-icons';

import styles from './CountrySearchInput.module.scss';
import Props from './CountrySearchInput.props';

const CountrySearchInput = ({ className, isLoading = false, ...otherProps }: Props) => {
  return (
    <div className={cn(styles.CountrySearchInput, className)}>
      <input type="text" {...otherProps} />
      {isLoading && <FontAwesomeIcon icon={faSpinnerThird} className={styles.Loader} />}
    </div>
  );
};

export default CountrySearchInput;
